/**
 * Text field can have the following rules, which affect style and functionality (admin app):
 * - RequiredIf - set * after the label
 * - EnableIf - set both input field and label to disabled, when False
 * - ReadOnlyIf - set both input field and label to readOnly
 */

import { Component, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { selectMessagesForOpenedEditorForProperty } from 'src/app/project/store/project-data/project-data.selectors';
import { TreeEntity } from '../../../core/models/entity.model';
import { EntityPropertyBaseComponent } from '../entity-property-base/entity-property-base.component';

@Component({
  selector: 'app-entity-property-text',
  templateUrl: './entity-property-text.component.html',
  styleUrls: ['./entity-property-text.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class EntityPropertyTextComponent extends EntityPropertyBaseComponent<string> implements OnChanges {
  protected messages: TreeEntity[] = [];

  messagesForOpenedEditorForProperty$ = (key: string) => this.store.select(selectMessagesForOpenedEditorForProperty(key, this.entityId));

  constructor(private store: Store) {
    super();
    this.messagesForOpenedEditorForProperty$ = (propertyKey: string) =>
      this.store.select(selectMessagesForOpenedEditorForProperty(this.property.Key, this.entityId)).pipe(take(1));
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes['property']) {
      this.messagesForOpenedEditorForProperty$(this.property.Key)
        .pipe(take(1))
        .subscribe(msgs => (this.messages = msgs));
    }
  }

  showCounter() {
    const setMaxLengthRule = this.property?.Rules['SetMaxLength'];
    return setMaxLengthRule !== undefined;
  }

  getMaxLength() {
    return this.property?.Rules.SetMaxLength;
  }

  getMinLength(propertyForm: UntypedFormControl) {
    return propertyForm.errors && propertyForm.errors['minlength'] && propertyForm.errors['minlength']['requiredLength'];
  }

  getCurrentLength(propertyForm: UntypedFormControl) {
    return (propertyForm.value && propertyForm.value.length) || 0;
  }
}
